import React, { Component, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import Link from 'redux-first-router-link';
import { connect } from 'react-redux';
import { isbot } from 'isbot';
import ArticleCard from './ArticleCard';
import VerticalModules from './VerticalModules';
import VerticalRecirculation from './VerticalRecirculation';
import Loading from '../App/Loading'; // can be a hasLoading() HOC in the future
import MetaTags from '../common/MetaTags';
import { segmentTrackPage, sendLog, isValid, isText, getFileName, setHtlTargetingAndPageview } from '../../utils';
import { determineCardType } from '../../imgixUtils';
import { SOCIAL_SHARE_IMAGE_DEFAULT, APP_ENV, SITE_HOST, HOMEPAGE_MAP, HOMEPAGE_VERTICAL_MAP } from '../../consts';


class Homepage extends Component {
  constructor() {
    super();
    this.state = {
    };
    this.renderCategory = this.renderCategory.bind(this);
  }

  componentDidMount() {
    if (this.props.isLoading) return;

    const title = (isValid(this.props.seo) && isText(this.props.seo.titleTag)) ? this.props.seo.titleTag : (isValid(this.props.landerMeta) && isText(this.props.landerMeta.title)) ? this.props.landerMeta.title : '';
    segmentTrackPage(title);

    const isTesting = APP_ENV === "PROD" ? "no" : "yes";
    const adType = null;
    const ua = navigator.userAgent;
    const bot = isbot(ua) ? 'bot' : 'human';

    setHtlTargetingAndPageview({
      context: "homepage:mount",
      targeting: {
        ad_type: adType,
        is_testing: isTesting,
        is_home: "yes",
        category: "homepage",
        env: APP_ENV,
        brand_safety_cat: "none",
        brand_safety_rating: "none",
        brand_safety: "lander",
        ua: bot,
      },
    });
  }

  componentDidUpdate(prevProps) {
    // Segment page call for homepage navigating from an article
    if (prevProps.brand === '' && this.props.brand === 'purewow' && this.props.category === '' && !this.props.isLoading) {
      const title = (isValid(this.props.seo) && isText(this.props.seo.titleTag)) ? this.props.seo.titleTag : (isValid(this.props.landerMeta) && isText(this.props.landerMeta.title)) ? this.props.landerMeta.title : '';
      segmentTrackPage(title);
    }
    if (prevProps.category !== this.props.category || (prevProps.category === '' && this.props.category !== '' && prevProps.brand === '')) {
      const isTesting = APP_ENV === "PROD" ? "no" : "yes";
      const adType = null;
      const ua = navigator.userAgent;
      const bot = isbot(ua) ? 'bot' : 'human';

      setHtlTargetingAndPageview({
        context: "homepage:update",
        targeting: {
          ad_type: adType,
          is_testing: isTesting,
          is_home: "yes",
          category: "homepage",
          env: APP_ENV,
          brand_safety_cat: "none",
          brand_safety_rating: "none",
          brand_safety: "lander",
          ua: bot,
        },
      });
    }
  }

  renderCategory(category, title, articleCards, hasArrow) {
    const { isClient, isMobile, adUnit } = this.props;

    const renderedArticleCards = isValid(articleCards) ? articleCards.map((articleCard, i) => {
      articleCard.cardClass = "big-card";
      return (
        <ArticleCard key={i} data={articleCard} isMobile={isMobile} shouldDisplaySponsored={true} showCategory={true} isClient={isClient}/>
      );
    }) : null;

    return (
      <div className='category-outer-wrapper col-12 col-4-sm'>
        <div className={`category-wrapper ${category} col-12 col-4-sm`}>
          <h2 className={`category-name ${category}`} dangerouslySetInnerHTML={{ __html: title }}></h2>
          { hasArrow && 
            <Link className="category-link" to={{ type: 'LANDER', payload: { category: category } }}>
              <div className='read-more'>Read more {title}</div>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="#1E1E1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </Link>
          }
        </div>
        <div className='article-cards col-12'>
          {renderedArticleCards}
        </div>
      </div>
    );
  }

  render() {
    const {
      adUnit,
      latest,
      ourPicks,
      wellness,
      food,
      family,
      fashion,
      style,
      articles,
      seo,
      brand,
      category,
      subcategory,
      isLoading,
      landerMeta,
      isMobile,
      isClient,
      shouldDestroyAds,
      onShowLeaderboard,
      modules,
      pageType,
    } = this.props;

    if (isLoading) {
      return <Loading />;
    }
    if (isClient) {
      if (isMobile) {
        onShowLeaderboard(false, adUnit);
      } else {
        onShowLeaderboard(true, adUnit);
      }
    }
  
    const dfpComment = `<!-- DFPP Hierarchy/Targeting:
          Page Type: lander
          Ad Unit: ${adUnit}
          env: ${APP_ENV} -->`;

    let className = `${brand}-lander homepage vertical grid-container`;
    const isTesting = APP_ENV === "PROD" ? "no" : "yes";
    const landerURL = SITE_HOST;
    let metaTitle = (isValid(seo) && isText(seo.titleTag)) ? seo.titleTag : (isValid(landerMeta) && isText(landerMeta.title)) ? landerMeta.title : '';
    let metaDescription = (isValid(seo) && isText(seo.metaDescription)) ? seo.metaDescription : (isValid(landerMeta) && isText(landerMeta.description)) ? landerMeta.description : '';
    const renderedStyleAndFood = [
      style
        ? this.renderCategory('style', "Style", style, true)
        : this.renderCategory('fashion', "Style", fashion, true),
      this.renderCategory('food', "Food", food, true),
    ];
    const renderedFamilyAndWellness = [
      this.renderCategory('family', "Family", family, true),
      this.renderCategory('wellness', "Wellness", wellness, true),
    ];

    const featuredStories = isValid(modules) ? modules.filter(module => module.type === "featured-story") : null;
    const hasTopFeatured = isValid(modules) ? modules[0].type === "featured-story" : false;
    const ua = isClient && typeof navigator !== "undefined" ? navigator.userAgent : "";
    const bot = isbot(ua) ? 'bot' : 'human';

    return (
      <Fragment>
        <MetaTags
          title={metaTitle}
          description={metaDescription}
          url={landerURL}
          ogTitle={metaTitle}
          ogDescription={metaDescription}
          ogImage={SOCIAL_SHARE_IMAGE_DEFAULT}
          ogImageWidth="600px"
          ogImageHeight="315px"
          twitterImg={SOCIAL_SHARE_IMAGE_DEFAULT}
          twitterDescription={metaDescription}
          canonicalUrl={landerURL} 
          isFeaturedContent={false}
          rssCategory="homepage"/>

        <div className={className}>
            <div dangerouslySetInnerHTML={ { __html: dfpComment } }/>
            <VerticalModules modules={modules.slice(0, 4)} isMobile={isMobile} adUnit={adUnit} shouldDisplayAds={true} hasTopFeatured={hasTopFeatured} featuredStories={featuredStories} isHomepage={true} firstSet={true} isClient={isClient}/>
            {renderedStyleAndFood}
            <div className='htlad-purewow_lander_interstitial lander-interstital-ad'
              data-unit={adUnit} 
              data-targeting='{"slot_name":"purewow_lander_interstitial"}'>
            </div>
            <VerticalModules modules={modules.slice(4, 6)} isMobile={isMobile} adUnit={adUnit} shouldDisplayAds={true} hasTopFeatured={hasTopFeatured} featuredStories={featuredStories} isHomepage={true} firstSet={false} isClient={isClient}/>
            {renderedFamilyAndWellness}
            <div className='htlad-purewow_lander_interstitial lander-interstital-ad'
              data-unit={adUnit} 
              data-targeting='{"slot_name":"purewow_lander_interstitial"}'>
            </div>
            <VerticalModules modules={modules.slice(6)} isMobile={isMobile} adUnit={adUnit} shouldDisplayAds={true} hasTopFeatured={hasTopFeatured} featuredStories={featuredStories} isHomepage={true} firstSet={false} isClient={isClient}/>
            <VerticalRecirculation articles={articles} category="homepage" isMobile={isMobile} isClient={isClient} adUnit={adUnit} showCategory={true}/>
        </div>
      </Fragment>
    );
  }
}
const mapState = (state) => {
  const {
    pageData,
    isMobile,
    isClient,
} = state;
  const {
    pageType, articles, seo, brand, landerMeta, adUnit, isLoading, shouldDestroyAds,
  } = pageData;

  /*
    Handles first action dispatched when clicking redux-first-router Link or NavLink.

    This first action just updates the location in the redux store but doesn't fetch any data
    or update the actual contents of the page.

    A second action is dispatched once the thunk associated with the new route/location finishes running.
    In this case, the thunk internally makes an async request to the server to get new data based on the redux
    state's location.
  */

  // should be able to key off isLoading instead.
  if (pageType !== 'lander' && pageType !== 'vertical') {
    return {
      wellness: [],
      food: [],
      family: [],
      fashion: [],
      style: [],
      articles: [],
      seo: {},
      brand: '',
      category: '',
      isLoading: true,
      isMobile,
      isClient,
      shouldDestroyAds,
      pageType,
    };
  }

  const { category, wellness, food, family, style, fashion, modules } = pageData;

  return {
    wellness,
    food,
    family,
    style,
    fashion,
    modules,
    articles,
    seo,
    brand,
    category,
    isLoading,
    isMobile,
    landerMeta,
    isClient,
    adUnit,
    shouldDestroyAds,
    pageType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onShowLeaderboard: (shouldShowAd, adUnit) => {
      dispatch({
        type: 'SHOW_LEADERBOARD',
        shouldShowAd,
        adUnit,
      });
    },
  };
};

export default connect(mapState, mapDispatchToProps)(Homepage);
